import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Kube } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditKube from './EditKube.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        kube: Kube;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'KubeTableActions',
  props: {
    kube: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.kube }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).SYSTEM_UPDATE))
        ? (_openBlock(), _createBlock(EditKube, {
            key: 0,
            kube: _ctx.kube
          }, null, 8, ["kube"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).SYSTEM_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.kube.destroy', _ctx.kube.id),
            "query-key": [_unref(QueryKey).KUBE],
            header: "kube.delete.title",
            description: "kube.delete.content"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})